import { render, staticRenderFns } from "./DivisionsForm.vue?vue&type=template&id=f2056e7c&"
import script from "./DivisionsForm.vue?vue&type=script&lang=js&"
export * from "./DivisionsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports